module.exports = __webpack_public_path__ + "img/timer.f7dbdc70.svg";